var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Backbone from "backbone";
var Relay = /** @class */ (function (_super) {
    __extends(Relay, _super);
    function Relay(attributes, options) {
        return _super.call(this, attributes, options) || this;
    }
    Relay.prototype.initialize = function () {
        this.disabled = false;
    };
    Relay.prototype.disable = function () {
        this.disabled = true;
    };
    Relay.prototype.enable = function () {
        this.disabled = false;
    };
    Relay.prototype.isDisabled = function () {
        return this.get("disabled") || this.disabled;
    };
    return Relay;
}(Backbone.Model));
export { Relay };
var RelayStore = /** @class */ (function (_super) {
    __extends(RelayStore, _super);
    function RelayStore() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.model = Relay;
        return _this;
    }
    RelayStore.prototype.disableRelay = function (name) {
        var relay = this.find(function (relay) { return relay.get("name") === name; });
        if (relay)
            relay.disabled = true;
    };
    RelayStore.prototype.getRelayFor = function (type) {
        return this.find(function (relay) {
            return !relay.isDisabled() && (relay.get("capabilities").indexOf(type) !== -1);
        });
    };
    RelayStore.prototype.resetRelays = function () {
        this.each(function (relay) { return relay.enable(); });
    };
    return RelayStore;
}(Backbone.Collection));
export { RelayStore };
export default new RelayStore();
